// PostHog is disabled. This plugin provides a no-op `$posthog` so the existing
// analytics call sites keep working without loading posthog-js or sending any
// data. To re-enable, restore the posthog-js implementation from git history.
export default defineNuxtPlugin({
  name: "posthog",
  parallel: true,
  setup() {
    const noop = {
      capture: (_event: string, _properties?: Record<string, any>) => {},
      identify: (_distinctId?: string, _properties?: Record<string, any>) => {},
      reset: () => {},
    };

    return {
      provide: {
        posthog: noop,
      },
    };
  },
});
